module.exports = __webpack_public_path__ + "static/media/heart-icon.44c850bb.svg";